import React, {useContext, useState} from 'react';

import i18nStrings from './strings';
import styles from './styles.modules.scss';
import {useLocalized} from 'utils/useLocalized';
import Icon from '@components/icon';
import interpolate from 'ati-utils/interpolate';
import pluralize from 'ati-utils/pluralize';
import {DataContext, LocaleContext} from 'contexts';
import Button from '@components/button';
import * as PropTypes from 'prop-types';
import BoardsPopoverContainer from 'components/Page/SearchResults/BoardsPopoverContainer';
import ScrollsPopoverContainer from 'components/Page/SearchResults/ScrollsPopoverContainer';
import {eventMetrics} from 'logic/requestParams';
import Link from '@components/link';
import Informer from 'components/Informer';
import { EnablerFeatures } from 'consts/consts';

const SelectedFirmsActionsBanner = ({searchResultsSelected}) => {
    const strings = useLocalized(i18nStrings);
    const locale = useContext(LocaleContext);
    const { handleAllSearchResultsSelection, writeEvent, enablerFeatures } = useContext(DataContext);
    const [boardsPopoverVisible, setBoardsPopoverVisible] = useState(false);
    const [scrollsPopoverVisible, setScrollsPopoverVisible] = useState(false);
    const searchResultsSelectedIds = searchResultsSelected.map(sr => sr.id);

    const boardsPopoverContainer = (
        <BoardsPopoverContainer
            atiIds={searchResultsSelectedIds}
            visible={boardsPopoverVisible}
            onPopoverVisibleChange={setBoardsPopoverVisible}
        >
            <Button
                outlined
                before={(
                    <Icon
                        height={16}
                        name="ic_plus-solid"
                        width={16}
                    />
                )}
                className={styles['action-btn']}
                size="small"
                theme="secondary"
                onClick={() => writeEvent(eventMetrics.openInviteToBoards, searchResultsSelectedIds)}
            >
                {strings.addToBoards}
            </Button>
        </BoardsPopoverContainer>
    );

    return (
        <div className={styles['selected-firms-actions-banner']}>
            <div className={styles['selection-col']}>
                <div className={styles['selected-firms']}>
                    {
                        interpolate
                        (
                            pluralize(strings.firmsCountSelectedPlural, searchResultsSelected.length, locale),
                            {
                                count: searchResultsSelected.length
                            }
                        )
                    }
                    <Icon
                        className={styles['close-button']}
                        color="#39444F"
                        height={14}
                        name="ic_none"
                        width={14}
                        onClick={() => handleAllSearchResultsSelection(false)}
                    />
                </div>
                <Link
                    as="button"
                    size="large"
                    onClick={() => handleAllSearchResultsSelection(true)}
                >
                    {strings.selectAllOnThePage}
                </Link>
            </div>
            <div className={styles['invite-col']}>
                {boardsPopoverVisible ? boardsPopoverContainer : (
                    <Informer
                        description={strings.addSelectedToBoards}
                        locale={locale}
                        popoverFeature={enablerFeatures[EnablerFeatures.inviteAllTruckersToBoardsInformer]}
                    >
                        {boardsPopoverContainer}
                    </Informer>
                )}
                <ScrollsPopoverContainer
                    atiIds={searchResultsSelectedIds}
                    visible={scrollsPopoverVisible}
                    onPopoverVisibleChange={setScrollsPopoverVisible}
                >
                    <Button
                        outlined
                        before={(
                            <Icon
                                height={16}
                                name="ic_plus-solid"
                                width={16}
                            />
                        )}
                        className={styles['action-btn']}
                        size="small"
                        theme="secondary"
                        onClick={() => writeEvent(eventMetrics.openAddToList, searchResultsSelectedIds)}
                    >
                        {strings.addToList}
                    </Button>
                </ScrollsPopoverContainer>
            </div>
        </div>
    );
};

SelectedFirmsActionsBanner.propTypes = {
    searchResultsSelected: PropTypes.array,
};


export default SelectedFirmsActionsBanner;
